// general
export const TIMEOUT_MINS = 60 * 10  // 10 hours

// content types
export const CONTENTTYPE_IDENTITY = 12
export const CONTENTTYPE_EMPLOYER = 16
export const CONTENTTYPE_CLIENT = 20
export const CONTENTTYPE_CASE = 22
export const CONTENTTYPE_SAVING = 24
export const CONTENTTYPE_FILE = 38
export const CONTENTTYPE_EMAIL = 45
export const CONTENTTYPE_MESSAGE = 49
export const CONTENTTYPE_LOANAPPLICATION = 51
export const CONTENTTYPE_CONSOLIDATION = 55
export const CONTENTTYPE_LOAN = 58
export const CONTENTTYPE_CLIENTINSTRUMENT = 60
export const CONTENTTYPE_CLIENTFUNERALPOLICY = 62
export const CONTENTTYPE_REQUESTRUN = 121
export const CONTENTTYPE_PAYROLLRUN = 129
export const CONTENTTYPE_CREDITAPPLICATION = 133
export const CONTENTTYPE_CREDIT = 134
export const CONTENTTYPE_WHATSAPPMESSAGE = 135
export const CONTENTTYPE_WITHDRAWAL = 164  // 164 on local

// file type node ids
export const FILETYPE_PAYSLIP = "RmlsZVR5cGVOb2RlOjEwYTQ0MGE1LWM0ZjctNGQ1Yi1hYTBkLWNiNjc3ZWQwNTg0Ng=="
export const FILETYPE_RETAIL_INVOICE = "RmlsZVR5cGVOb2RlOmRjZWY3NjBiLTc1ZjItNGRiMS05OGE1LTY0ZmYyMTEwMTZhZg=="
export const FILETYPE_LOANAPPLICATION = "RmlsZVR5cGVOb2RlOjIwZTQ5M2QxLTdkZmEtNDllYy1iMzA4LWU2ZTBmYzNkZmU2OA=="
export const FILETYPE_LOANAPPLICATION_CONSOLIDATION_STATEMENT = "RmlsZVR5cGVOb2RlOjdlNGRkY2MxLTlkYTktNGI0NC1iZmZiLTU4YjBjNzA4ZjlmZQ=="
export const FILETYPE_LOAN_PROOF_OF_PAYMENT = "RmlsZVR5cGVOb2RlOmY2MTRiMjAyLWRmZWUtNDRmMC1iYmYxLTEwMjk5ODZmMGE0OQ=="
export const FILETYPE_MANUAL_UPLOAD = "RmlsZVR5cGVOb2RlOmViN2ZlNDk4LTQ5MmQtNGFmMC1hMzYxLWNkYjA2NDBjNDE0MA=="
export const FILETYPE_TWOADAY_PAYSLIP = "RmlsZVR5cGVOb2RlOmUwOTUzNTU5LTBiMzQtNDIzNS05ZWZhLTQ5M2Y1YTkyYTJiZA=="
// application forms
export const FILETYPE_FORM_APPLICATION_ASSOCIATION_MEMBER = "RmlsZVR5cGVOb2RlOjI2NDIzYWM4LTExODYtNGEzMy1hNDgxLWU5ZmFkNGQxZTgxOA=="
export const FILETYPE_FORM_APPLICATION_REWARDS = "RmlsZVR5cGVOb2RlOjMwYjNiZTA2LWJkMmYtNDNlNy1iMmQ5LTI3NDQ4MDkwYTJmNg=="
export const FILETYPE_FORM_APPLICATION_INVESTMENTS = "RmlsZVR5cGVOb2RlOmYzYTBkMTE3LWQ3MzUtNDBlMC1hNzE2LTIxMzU0OTgzMWM4Zg=="
export const FILETYPE_FORM_APPLICATION_FUNERAL_COVER_VOLUNTARY = "RmlsZVR5cGVOb2RlOjZiNmQ0N2EzLTgzZDEtNDVkYi05OGY2LTZjZTMxYTc3NjJhNw=="
export const FILETYPE_FORM_APPLICATION_FUNERAL_COVER_EXTENDED_FAMILY = "RmlsZVR5cGVOb2RlOmE4ZTZhMTcwLTVkOWEtNDlhMi04Yjk1LWRmNGRkNWI0NWIwMg=="
// forms
export const FILETYPE_FORMS = "RmlsZVR5cGVOb2RlOjJhZWE4OWE0LWY3MGYtNGExMS1hZGNjLTdkNzI1MGZjMjc3Yw=="
// short codes
export const FILETYPE_LOANAPPLICATION_SHORTCODE = 'CLA'
export const FILETYPE_PAYSLIP_SHORTCODE = 'CPS'
export const FILETYPE_RETAIL_INVOICE_SHORTCODE = 'CRI'
export const FILETYPE_CONSOLIDATION_STATEMENT_SHORTCODE = 'CSS'

// Picsa identities
export const IDENTITY_PICSAOS = "SWRlbnRpdHlOb2RlOjNjZjI1NDBjLWRmNjItNDBmNC1hNzQ2LTdiNjM5ZTZkOGY4Mw=="
export const IDENTITY_PICSA_ADVISORY_SERVICES = "SWRlbnRpdHlOb2RlOmQ0ZWUyM2UwLTdlYzUtNDdiYy04ODM5LWNlMzdlZWZlZjMzMQ=="
export const IDENTITY_DANELL = "SWRlbnRpdHlOb2RlOmZmNzg5ZDlhLTBlNjktNDQ2MS05YmE5LWFiODY5ZjFkYjcyZQ=="
export const IDENTITY_CAROL = "SWRlbnRpdHlOb2RlOmNlNTgxZmM0LTY4ZjctNGRkYy05M2NjLTIwOWQ0YjUxMGYxMg=="
export const IDENTITY_DION = "SWRlbnRpdHlOb2RlOjNlN2RjMTdjLTc0YjItNGYyYS05NmFjLTNlYTgxNGQwZWUwMA=="
export const IDENTITY_THIAN = "SWRlbnRpdHlOb2RlOmY3ZTg0NGY3LWFiZWItNDA1NC04NjIwLWMwZTdjZGFmZjVjNw=="
export const EMPLOYER_PICSA_ADVISORY_SERVICES = "RW1wbG95ZXJOb2RlOmUwMjNkODU2LWEyNzQtNGVlMi04NGViLWMxNjgyZmE2ZTI1MQ=="

// message channel ids
export const CHANNEL_SMS = "Q2hhbm5lbE5vZGU6YTgzNWRhM2YtNTc5NS00ZjEzLThlMGUtM2RlZjUxM2I1MjRi"
export const CHANNEL_SMS_MESSAGEPLUS = "Q2hhbm5lbE5vZGU6YzNjYTZlOTAtMDRjNi00YzcwLWEyMDAtZDA0NGNmODlmNzVl"

export const WORKFLOW_RECEIPT_INVESTMENTS = "V29ya2Zsb3dOb2RlOjQ1Y2MxYmMwLWFkMzktNGIxOS05NjY1LWNmZjYyOTQzY2U3ZA=="
export const WORKFLOW_LOAN_DISBURSAL = "V29ya2Zsb3dOb2RlOjJmMTUwNmVlLTQyZjYtNDEzNC05OTY3LWY0N2RhMTFkNWM5ZQ=="

// product colour constants
export const COLOUR_CASH_LOAN_1 = '#edf4f2'
export const COLOUR_CASH_LOAN_2 = '#7dbc42'  // can be used if 'accent' as is brighest of 3
export const COLOUR_CASH_LOAN_3 = '#23894d'

export const COLOUR_RETAIL_LOAN_1 = '#f1f6fa'
export const COLOUR_RETAIL_LOAN_2 = '#49c2cc'  // can be used if 'accent' as is brighest of 3
export const COLOUR_RETAIL_LOAN_3 = '#007c95'

export const COLOUR_CONSOLIDATION_LOAN_1 = '#fdf5e6'
export const COLOUR_CONSOLIDATION_LOAN_2 = '#ffc433'  // can be used if 'accent' as is brighest of 3
export const COLOUR_CONSOLIDATION_LOAN_3 = '#e89d1a'

export const COLOUR_FUNERAL_COVER_1 = '#f8f6f2'
export const COLOUR_FUNERAL_COVER_2 = '#e8e0d5'  // can be used if 'accent' as is brighest of 3
export const COLOUR_FUNERAL_COVER_3 = '#5a544a'

// forms
export const FORM_INVESTMENT_WITHDRAWAL_APPLICATION = "Rm9ybU5vZGU6MGRiY2Q2OWItZDlhMC00MGFlLThmZDItOTI5NDg3ODc2YTQx"

// request types
export const REQUESTTYPE_INVESTMENT_WITHDRAWAL_APPLICATION = "UmVxdWVzdFR5cGVOb2RlOmRkZjA4YzUxLWM4OTQtNDQzNC1hNzEwLTYxNWFhMjkzOThmYQ=="
export const REQUESTTYPE_INVESTMENT_APPLICATION = "UmVxdWVzdFR5cGVOb2RlOjExZDQ4NmNjLWUxZDktNDViZi1iZjcwLTJiMmViNzk1YTY5Yw=="
export const REQUESTTYPE_LOANAPPLICATION = "UmVxdWVzdFR5cGVOb2RlOjA0OGVhODEyLWNlZTgtNDRhZi1iYTk2LThjNWYzNDEwNDg5ZQ=="
export const REQUESTTYPE_CREDITAPPLICATION = "UmVxdWVzdFR5cGVOb2RlOjgwODZmZjc5LTkzN2QtNDFmMC04ZDRlLTc2ZTc3YjgwNzAxNg=="
export const REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE = "UmVxdWVzdFR5cGVOb2RlOjdjYjZiZGJiLTEwOWEtNDAyZC05NTZkLTllN2JkZTJlZDlhOQ=="
export const REQUESTTYPE_CLIENT_TERMINATION = "UmVxdWVzdFR5cGVOb2RlOmZhYWU1YTU1LTU0ZjMtNDVlZS1hZmQ4LTU3ZmY3NmI3ZjVmYg=="

// impact report
export const IMPACT_REPORT_DATE = '2021-08-07'

// metrics
export const METRIC_PICSA_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZTpkYjc2ZjkwYy1kN2ZiLTQ2ZmYtOWMwNC1iMTE3ODMzYjk4YzQ='
export const METRIC_CLIENT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToyOTIzZDM5ZC0yNjRjLTQ4YzQtYTdjZi04Mzc0MGVmMjAwMDA='
export const METRIC_INVESTMENT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZTozMTliYmM3NS01ZTRhLTQzZDUtOWU0ZS05MGMwMDNiNGRmZjA='
export const METRIC_CREDIT_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToyZGEzMjJjNC1mZGRjLTQ0MTktOTFlOS1hNmU2MjExZTcxNDM='
export const METRIC_EMPLOYER_DAILY_SUMMARY = 'TWV0cmljU291cmNlTm9kZToxZGNmNzI5MS1hZTVjLTQ3MGYtOWE5Yi0zY2FkMDkwZDJlODY='

// cases
export const CASE_TYPE_MAP_EDIT = {
  '': [
    'Choose Product'
  ],
  funeral: [
    '',
    'Application',
    'Complaints',
    'Compliments',
    'Extended Family Cover',
    'General Enquiries',
    'Product Information Request',
    'Special Requests/ Exceptions',
  ],
  debtcounselling: [
    '',
    'Application',
    'Complaints',
    'Compliments',
    'General Enquiries',
    'Referrals',
    'Special Requests/ Exceptions',
  ],
  campaign: [
    '',
    'Complaints',
    'Compliments',
    'Data Clean-up',
    'Debt Consolidation',
    'Earnbacks',
    'Emergency Savings',
    'Financial Education',
    'Funeral Cover',
    'General Enquiries',
    'Investments - Long-term',
    'Investments - Short-term',
    'Loans',
    'Non-Active Members',
    'Outbound Call',
    'SMS Campaign',
    'Video Campaign',
  ],
  loans: [
    '',
    'Application',
    'Bad Debt',
    'Balance Enquiry',
    'Change Amount',
    'Client Confirmation Required',
    'Complaints',
    'Compliments',
    'Deductions',
    'Employer Confirmation Required',
    'General Enquiries',
    'Loan Exceptions',
    'Overdeduction Repayment',
    'Product Information Request',
    'Retail Finance',
    'Settlement',
    'Special Requests/ Exceptions',
  ],
  picsaaccount: [
    '',
    'Application',
    'Bank Account Creation',
    'Call Back Request',
    'Client Confirmation Required',
    'Complaints',
    'Compliments',
    'Employer Confirmation Required',
    'General Enquiries',
    'Product Information Request',
    'Special Requests/ Exceptions',
  ],
  other: [
    '',
    'Call Back Request',
    'Complaints',
    'Compliments',
    'Data Request',
    'General Enquiries',
    'Referrals',
    'Special Requests/ Exceptions',
    'Unallocated Request',
    'Unknown Sender',
  ],
  savings: [
    '',
    'Application',
    'Balance Enquiry',
    'Change Amount',
    'Complaints',
    'Compliments',
    'Deductions',
    'General Enquiries',
    'Payout | Emergency Savings',
    'Payout | Long-term',
    'Payout | Short-term',
    'Product Information Request',
    'Special Requests/ Exceptions',
    'Statements',
  ],
  earnbacks: [
    '',
    'Application',
    'Complaints',
    'Compliments',
    'General Enquiries',
    'Special Requests/ Exceptions',
  ],
  picsaatwork: [
    '',
    'Debt Couselling',
    'Earnbacks',
    'Education',
    'Funeral Cover',
    'Loans',
    'Membership',
    'Picsa Offering',
    'Savings / Investments',
  ],
};

// FILTER options include All option and may include archived options that should no longer be used for new cases
export const CASE_TYPE_MAP_FILTER = {
  '': ['All'],
  funeral: [
    'All',
    'Application',
    'Complaints',
    'Compliments',
    'Extended Family Cover',
    'General Enquiries',
    'Product Information Request',
    'Special Requests/ Exceptions',
    '---',
    // background
    'Data Hygiene',
    // archived
    'Documents',
  ],
  debtcounselling: [
    'All',
    'Application',
    'Complaints',
    'Compliments',
    'General Enquiries',
    'Referrals',
    'Special Requests/ Exceptions',
  ],
  campaign: [
    'All',
    'Complaints',
    'Compliments',
    'Data Clean-up',
    'Debt Consolidation',
    'Earnbacks',
    'Emergency Savings',
    'Financial Education',
    'Funeral Cover',
    'General Enquiries',
    'Investments - Long-term',
    'Investments - Short-term',
    'Loans',
    'Non-Active Members',
    'Outbound Call',
    'SMS Campaign',
    'Video Campaign',
    '---',
    // archived
    'AFGRI | Rollout Status',
    'AFGRI | Signed Beneficiary',
    'AFGRI | Signed Consent Form',
    'Special Requests/ Exceptions',
  ],
  loans: [
    'All',
    'Application',
    'Bad Debt',
    'Balance Enquiry',
    'Change Amount',
    'Client Confirmation Required',
    'Complaints',
    'Compliments',
    'Deductions',
    'Employer Confirmation Required',
    'General Enquiries',
    'Loan Exceptions',
    'Overdeduction Repayment',
    'Product Information Request',
    'Retail Finance',
    'Settlement',
    'Special Requests/ Exceptions',
    '---',
    // background
    'Data Hygiene',
    // archived
    'Documents',
  ],
  picsaaccount: [
    'All',
    'Application',
    'Bank Account Creation',
    'Call Back Request',
    'Client Confirmation Required',
    'Complaints',
    'Compliments',
    'Employer Confirmation Required',
    'General Enquiries',
    'Product Information Request',
    'Special Requests/ Exceptions',
    '---',
    // background
    'Data Hygiene',
    'Data Request',
    'Deductions Handling',
    'Termination',
    // archived
    'Documents',
  ],
  other: [
    'All',
    'Call Back Request',
    'Complaints',
    'Compliments',
    'Data Request',
    'General Enquiries',
    'Referrals',
    'Special Requests/ Exceptions',
    'Unallocated Request',
    'Unknown Sender',
    '---',
    // background
    'Request Validation Failed'
  ],
  savings: [
    'All',
    'Application',
    'Balance Enquiry',
    'Change Amount',
    'Complaints',
    'Compliments',
    'Deductions',
    'General Enquiries',
    'Payout | Emergency Savings',
    'Payout | Long-term',
    'Payout | Short-term',
    'Product Information Request',
    'Special Requests/ Exceptions',
    'Statements',
    '---',
    // archived
    'Documents',
    // archaic
    // 'Payout',
  ],
  earnbacks: [
    'All',
    'Application',
    'Complaints',
    'Compliments',
    'General Enquiries',
    'Special Requests/ Exceptions',
  ],
  picsaatwork: [
    'All',
    'Debt Couselling',
    'Earnbacks',
    'Education',
    'Funeral Cover',
    'Loans',
    'Membership',
    'Picsa Offering',
    'Savings / Investments',
  ]
}

// nodes to urls
export const NODES = {
  'IdentityNode': {
    base: '/os',
    endpoint: '/identity',
    query: `
      query($id: ID!) {
        object: identity(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'identity'
  },
  'RequestRunNode': {
    base: '/os/operations/general',
    endpoint: '/requests',
    query: `
      query($id: ID!) {
        object: requestrun(id: $id) {
          id
          summary
          context: identity {
            id
          }
        }
      }
    `,
    contentTypeModel: 'requestrun'
  },
  'CaseNode': {
    base: '/os',
    endpoint: '/cases',
    query: `
      query($id: ID!) {
        object: case(id: $id) {
          id
          context: affects {
            id
          }
        }
      }
    `,
    contentTypeModel: 'case'
  },
  'FileNode': {
    base: '/os/operations/general',
    endpoint: '/files',
    query: `
      query($id: ID!) {
        object: file(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'file'
  },
  'WhatsappMessageNode': {
    base: '/os/communications',
    endpoint: '/whatsapp',
    query: `
      query($id: ID!) {
        object: whatsappmessage(id: $id) {
          id
          summary
          context: fromIdentity {
            id
          }
        }
      }
    `,
    contentTypeModel: 'whatsappmessage'
  },
  'PayrollRunNode': {
    base: '/os/operations/general',
    endpoint: '/payrollruns',
    query: `
      query($id: ID!) {
        object: payrollrun(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'payrollrun'
  },
  'EmailNode': {
    base: '/os/communications',
    endpoint: '',
    query: `
      query($id: ID!) {
        object: email(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'email'
  },
  'MessageNode': {
    base: '/os/communications',
    endpoint: '',
    query: `
      query($id: ID!) {
        object: message(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'message'
  },
  'CreditNode': {
    base: '/os/products',
    endpoint: '/credit',
    query: `
      query($id: ID!) {
        object: credit(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'credit'
  },
  'CreditApplicationNode': {
    base: '/os/products/credit',
    endpoint: '/applications',
    query: `
      query($id: ID!) {
        object: creditapplication(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'creditapplication'
  },
  'LoanNode': {
    base: '/os/products',
    endpoint: '/credit',
    query: `
      query($id: ID!) {
        object: loan(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'loan'
  },
  'LoanApplicationNode': {
    base: '/os/products/credit',
    endpoint: '/applications',
    query: `
      query($id: ID!) {
        object: loanapplication(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'loanapplication'
  },
  'ClientInstrumentNode': {
    base: '/os/products',
    endpoint: '/investments',
    query: `
      query($id: ID!) {
        object: clientinstrument(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'clientinstrument'
  },
  'ClientFuneralPolicyNode': {
    base: '/os/products',
    endpoint: '/insurance',
    query: `
      query($id: ID!) {
        object: clientfuneralpolicy(id: $id) {
          id
          summary
          context: client {
            id
            identity {
              id
            }
          }
        }
      }
    `,
    contentTypeModel: 'clientfuneralpolicy'
  },
  'WorkflowRunNode': {
    base: '/os/operations/general',
    endpoint: '/workflows',
    query: `
      query($id: ID!) {
        object: workflowrun(id: $id) {
          id
          summary
        }
      }
    `,
    contentTypeModel: 'workflowrun'
  },
  // TODO: add more as/when needed
}

// listing pages
export const DEFAULT_RESULTS_PER_PAGE = 15

export const ACCOUNT_TYPE_EARNBACKS = 'QWNjb3VudFR5cGVOb2RlOjE4Njk0Zjc4LTdlNGEtNGM2Yy04NTQyLWQxNDUxNTg0N2ZlMQ=='
export const ACCOUNT_TYPE_EARNBACKS_MEMBERSHIP = 'QWNjb3VudFR5cGVOb2RlOjZhYzNlZWQ4LTY3MmEtNDZkMS1iNDgyLTUxMGNiM2Y1MzkwMQ=='

export const PAYROLL_RUN_FIRST_PAID_ON = '2017-11-02'



// WEBPACK FOOTER //
// ./src/constants.js